// extracted by mini-css-extract-plugin
module.exports = {"container":"MayPSearchFilter_container__2D4yF","label":"MayPSearchFilter_label__2mVlZ","deleteIcon":"MayPSearchFilter_deleteIcon__3WeKA"};